<template>
    <form
          @submit.prevent="loginByPhone"
          @click="recaptcha"
          class="enter-cabinet__tab form-vertical registration-phone"
    >
        <div v-if="authData.authInfo.showSMS">
            <span>{{authData.messages.phone_code_get_message}}</span>
        </div>

        <def-input
            v-if="userName"
            :required="userName.type !== 'hidden'"
            :label="userName.placeholder"
            :name="userName.name"
            :type="userName.type"
            :value="userName.value"
            :error="userName.error"
        />
        <!--     выбор авторизации через телефон или почту   -->
        <enter-cabinet-choose />
        <!--form-bottom-->
        <div class="enter-cabinet__tab form-vertical">
            <DefPhone
                v-if="userLogin"
                :required="userLogin.type !== 'hidden'"
                :label="authData.placeholder.phone"
                :name="userLogin.name"
                :type="userLogin.type"
                :value="userLogin.value"
                :error="errors && errors.loginBuyPhone"
            />
            <!--Главная кнопка для входа и регистрации-->
            <enter-cabinet-main-btn
                :btnValues="btnValues.codeSMS"
            />
        </div>
    </form>
</template>

<script>
import DefPhone from "../../def/DefPhone/DefPhone";
import {mapActions, mapState} from 'vuex';
export default {
    name: 'registration-phone',
    selector: '.registration-phone',
    components: {
        DefPhone,
    },
    computed: {
        ...mapState({
            authData: ({ personal }) => personal.data,
            activeTab: ({ personal }) => personal.data.activeTab,
            errors: ({ personal }) => personal.data.errors,
            btnValues: ({ personal }) => personal.data.btnValues,
        }),
        userName() {
            return this.authData.regInputs.find(el => el.name === 'USER_NAME' );
        },
        userLogin() {
            return this.authData.regInputs.find(el => el.name === 'USER_LOGIN' );
        },
    },
    methods: {
        ...mapActions({
            loginByPhone: 'personal/loginByPhone',
        }),
        loginByPhone(e) {
            this.$store.dispatch('personal/loginByPhone', { e, component: this });
        },
        /**
         * получения кода рекаптчи для отправки на сервер
         */
        async recaptcha() {
            // this.$store.dispatch('personal/recaptcha', { component: this });
        },
    }
}
</script>

<style lang="scss" scoped>
.registration-phone{
    width: 100%;
    :deep(.def-phone__placeholder){
        text-transform: none;
    }
}
</style>